import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import bemComponent from '@99designs/utils/app/bemComponent';

export class Main extends React.Component {
    render() {
        var classes = classNames({
            'fullscreen-main': true,
            'fullscreen-main--has-header': this.props.hasHeader,
        });

        return <div className={classes}>{this.props.children}</div>;
    }
}

Main.propTypes = {
    hasHeader: PropTypes.bool,
};

Main.defaultProps = {
    hasHeader: false,
};

export const Header = bemComponent('fullscreen-main__header', 'Header');
export const Body = bemComponent('fullscreen-main__body', 'Body');



// WEBPACK FOOTER //
// ./~/@99designs/fullscreen/components/Fullscreen.js